module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABDklEQVRIS92VsUoDURREzzQaXGMI2GivjcEP0S5G/IRg40dYa2WtHyCEtFairVgaxB8RUk14YQkb3ZA8sm9Bb/WKy8ydO8N9InEpMT71ENjeAK6BdkWKhpKeAtZUge194KNCgjtJVzOCiqYuhanHg9oV2N4FjiU9286AHrAZMcirpK9SD2yfAA9AU1JmuwsMIsBD66OkizkC21vADXCZg40lNfKUHQHT94r1Kem7GNMW8AYcFgBmBCuCLk6R7R3gHThIQpCvIZh5C/RLVtSJNHl+RUVttk+BeyCT1LR9HkyLXNNvk3+QhJh2JL3Y3gbOIhUsjmnkpEvb/8mpsL0HjJKd6+QfzlKn1mj4+yZPAEKPVhn4OxIgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_images/open.png
// module id = Tlbh
// module chunks = 83